import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType, TopNavigationTitle } from '@maestro/data-layer'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export const STICKY_READY_CLASS = 'header__sticky-ready'
export const STICKY_SHOW_CLASS = 'header__sticky-show'

export const useHeaderControls = () => {
  const { addOrUpdateHashParam } = useHash()
  const t = useTranslations('commerce-blocks')
  const { session } = useMaestroSession()
  const { publish } = useEventBusContext()

  const handleClickStore = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.STORE,
    })
  }, [publish])

  const handleClickWishlist = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.WISHLIST,
    })
    publish(EventType.SLIDE_IN_OPENED, {
      title: t('_globals.wishlist'),
      slideInType: 'wishlist',
      action: 'open',
    })
    addOrUpdateHashParam('wishlist')
  }, [addOrUpdateHashParam, publish, t])

  const handleClickLogin = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.LOGIN,
    })
    publish(EventType.SLIDE_IN_OPENED, {
      title: t('auth.login.title'),
      slideInType: 'login',
      action: 'open',
    })
    addOrUpdateHashParam('login')
  }, [addOrUpdateHashParam, publish, t])

  const handleClickMyAccount = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.LOGIN,
    })
  }, [publish])

  const handleClickCart = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.CART,
    })
    addOrUpdateHashParam('cart')
  }, [addOrUpdateHashParam, publish])

  const handleClickCartUrl = useCallback(() => {
    publish(EventType.TOP_NAVIGATION_CLICKED, {
      itemClicked: TopNavigationTitle.CART,
    })
  }, [publish])

  const isUserLoggedIn = useMemo(() => {
    return !!session?.user?.id
  }, [session?.user?.id])

  return {
    handleClickCart,
    handleClickCartUrl,
    handleClickLogin,
    handleClickMyAccount,
    handleClickStore,
    handleClickWishlist,
    isUserLoggedIn,
  }
}
